export default __webpack_public_path__ + "static/media/Devil-1_1.1274bf23.gif";